// Generated types for DerivedExpression
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { DerivedValueWriteAPI } from './derivedvalue';
import { ExpressionReadAPI, ExpressionWriteAPI } from './expression';
import { DerivedValueWriteAPISchema } from './derivedvalue';
import { ExpressionReadAPISchemaObject, ExpressionWriteAPISchemaObject } from './expression';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface DerivedExpressionReadAPI extends ExpressionReadAPI {
}

export interface DerivedExpressionWriteAPI extends ExpressionWriteAPI {
  mentions?: string[];
  /** The DerivedValue this expression computes (on `owner`, for `attribute`). Its `value` is written by evaluation only — never a ledger value, never typed by a caller. */
  result?: DerivedValueWriteAPI;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const DerivedExpressionReadAPISchema: z.ZodType<DerivedExpressionReadAPI> = ExpressionReadAPISchemaObject.extend({}).passthrough();

export const DerivedExpressionWriteAPISchema: z.ZodType<DerivedExpressionWriteAPI> = ExpressionWriteAPISchemaObject.extend({
  mentions: z.array(z.string()).optional(),
  result: z.lazy(() => DerivedValueWriteAPISchema).optional(),
}).passthrough();
